module.exports = {"440308001":"梅沙街道","440308002":"盐田街道","440308003":"沙头角街道","440308004":"海山街道","440308400":"市保税区（沙头角）","440308401":"市保税区（盐田港）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440308.json
// module id = 1971
// module chunks = 0